import { inject, Pipe, PipeTransform } from "@angular/core";
import { DateInput } from "../class/general-classes/date-helper";
import { DateStyle, LocaleService } from "../service/locale.service";

/**
 * Shows a date in the locale of the user: `{{ card.expiration | localDate: "dateTime" }}`.
 * The text follows the language of the application and changes as soon as the user picks another one.
 * Strings are read as {@link DateHelper.toDate} reads them; a missing or invalid date shows nothing.
 */
@Pipe({ name: "localDate", pure: false })
export class LocalDatePipe implements PipeTransform {
  private readonly _localeService = inject(LocaleService);
  private _lastKey: unknown;
  private _lastStyle?: DateStyle;
  private _lastLocale?: string;
  private _lastText = "";

  transform(value: DateInput | null | undefined, style: DateStyle = "date"): string {
    // Reading the locale signal here makes the view update when the language changes
    const locale = this._localeService.locale();
    const key = value instanceof Date ? value.getTime() : value;
    if (key !== this._lastKey || style !== this._lastStyle || locale !== this._lastLocale) {
      this._lastKey = key;
      this._lastStyle = style;
      this._lastLocale = locale;
      this._lastText = this._localeService.formatDate(value, style);
    }
    return this._lastText;
  }
}
